export default "__VITE_ASSET__g4tibzw7__"